import React, { Component } from "react";
import {
  profile,
  total,
  toFixed,
  format_date,
  GET,
  loading,
  Status,
  DateRangePicker,
  Navbar,
} from "../../components/CustomComponent.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import RANK1 from "../../assets/images/rank/rank2.png";
import RANK2 from "../../assets/images/rank/rank3.png";
import RANK3 from "../../assets/images/rank/rank4.png";
import { Line } from "react-chartjs-2";
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_broker: [],
      data_deposits: [],
      data_withdrawals: [],

      count_customer: 0,

      filter_start_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        "yyyy-MM-dd",
        "en",
      ),
      filter_end_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        "yyyy-MM-dd",
        "en",
      ),
      filter_currency: "THB",
      array_date: [],
    };
  }

  async componentDidMount() {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
    );
    loading(false);
    await this.Get(0);
  }
  Get = async () => {
    const { filter_start_date, filter_end_date } = this.state;
    loading(true);
    let data_broker;
    let _date_start = format_date(filter_start_date, "yyyy-MM-dd", "en");
    let _date_end = format_date(filter_end_date, "yyyy-MM-dd", "en");
    let _array_date = [];
    let current = new Date(_date_start);

    while (current <= new Date(_date_end)) {
      _array_date.push(format_date(current, "dd/MM"));
      current.setDate(current.getDate() + 1); // เพิ่มทีละวัน
    }

    let [result_broker] = await Promise.all([
      GET("v1/admin/brokers", { page_size: 10, page: 1 }),
    ]);

    if (result_broker?.status) {
      data_broker = result_broker.data;
    }
    this.setState({
      data_broker,
    });
    loading(false);
  };
  render() {
    const { filter_currency, data_broker } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* Header: หัว hero + Filter (ช่วงวันที่ / สกุลเงิน) */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Overview</div>
                <div className="ar-title">Dashboard</div>
                <div className="ar-subtitle">
                  Welcome back, {profile?.full_name}! Here's your{" "}
                  {profile?.user_type.replaceAll("_", " ")} overview.
                </div>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{"\uf0b0"}</span>Filter
                </span>
              </div>
              <div className="ar-filter-foot">
                {global.currency?.map((item) => (
                  <button
                    type="button"
                    key={item.currency_code}
                    className={`ar-pill ${item.currency_code === filter_currency ? "active" : ""}`}
                    onClick={() => {
                      this.setState({ filter_currency: item.currency_code });
                      setTimeout(() => {
                        this.Get(1);
                      }, 100);
                    }}
                  >
                    {item.image}
                    <span className="ms-1">{item.currency_name}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mb-3">
              <div className="ar-table-card">
                <div className="ar-table-head flex-wrap gap-2">
                  <div>
                    <div className="ar-table-title">
                      <span className="icon me-2 pu-title-icon">
                        {"\uf0c0"}
                      </span>
                      Top 10 Brokers
                    </div>
                    <div className="ar-table-caption">
                      Highest performing brokers by volume
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-hover ar-table pu-table pu-table-compact">
                    <thead>
                      <tr>
                        <td className="wpx-50 text-center">#</td>
                        <td className="text-nowrap">Broker</td>
                        <td className="text-end text-nowrap">Deposits</td>
                        <td className="text-end text-nowrap">Withdrawals</td>
                        <td className="text-end text-nowrap">Balance</td>
                      </tr>
                    </thead>
                    <tbody>
                      {data_broker?.slice(0, 10)?.map((item, index) => (
                        <tr key={`array-${index}`}>
                          <td data-label="#" className="text-center">
                            {index + 1}
                          </td>
                          <td data-label="Broker" className="text-nowrap">
                            {item.name_en || item.name_th || "-"}
                          </td>
                          <td
                            data-label="Deposits"
                            className="text-end text-nowrap py-1"
                          >
                            <div>
                              <div style={{ height: 14 }}>
                                {toFixed(
                                  item.gateway_active?.find(
                                    (e) => e.currency === filter_currency,
                                  )?.total_deposits || 0,
                                  2,
                                ) || "0.00"}
                              </div>
                              <small
                                className={
                                  item.gateway_active?.find(
                                    (e) => e.currency === filter_currency,
                                  )?.order_deposits
                                    ? "text-primary"
                                    : "text-secondary"
                                }
                              >
                                {item.gateway_active?.find(
                                  (e) => e.currency === filter_currency,
                                )?.order_deposits || 0}{" "}
                                orders
                              </small>
                            </div>
                          </td>
                          <td
                            data-label="Withdrawals"
                            className="text-end text-nowrap py-1"
                          >
                            <div>
                              <div style={{ height: 14 }}>
                                {toFixed(
                                  item.gateway_active?.find(
                                    (e) => e.currency === filter_currency,
                                  )?.total_withdrawals || 0,
                                  2,
                                ) || "0.00"}
                              </div>
                              <small
                                className={
                                  item.gateway_active?.find(
                                    (e) => e.currency === filter_currency,
                                  )?.order_withdrawals
                                    ? "text-primary"
                                    : "text-secondary"
                                }
                              >
                                {item.gateway_active?.find(
                                  (e) => e.currency === filter_currency,
                                )?.order_withdrawals || 0}{" "}
                                orders
                              </small>
                            </div>
                          </td>
                          <td
                            data-label="Balance"
                            className="text-end text-nowrap"
                          >
                            {item.wallets?.find(
                              (e) => e.currency === filter_currency,
                            )?.balance
                              ? toFixed(
                                  item.wallets?.find(
                                    (e) => e.currency === filter_currency,
                                  )?.balance,
                                  2,
                                )
                              : "0.00"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
